import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-sla-form',
  templateUrl: './sla-form.component.html',
  styleUrls: ['./sla-form.component.scss']
})
export class SlaFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
